import { Component, inject, signal, WritableSignal } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { InputTextModule } from 'primeng/inputtext';
import { FormsModule } from '@angular/forms';
import { DashboardStore } from '../stores/dashboard.store';
import { Dashboard } from '../models/dashboard';
import { IconPickerDialogComponent } from 'src/app/shared/dialogs/icon-picker-dialog/icon-picker-dialog.component';

@Component({
  selector: 'app-create-or-update-dashboard-dialog',
  imports: [
    ButtonModule,
    CommonModule,
    InputTextModule,
    FormsModule,
    IconPickerDialogComponent,
  ],
  templateUrl: './create-or-update-dashboard-dialog.component.html',
  styleUrl: './create-or-update-dashboard-dialog.component.css',
})
export class CreateOrUpdateDashboardDialogComponent {
  // Injected Services und Konfigurationen
  private config = inject(DynamicDialogConfig); // Konfiguration des Dialogs
  private ref = inject(DynamicDialogRef); // Referenz zum Dialog
  private messageService = inject(MessageService); // Service für Benachrichtigungen
  private store = inject(DashboardStore); // Store für Dashboard-Daten

  // Flag, ob ein neues Dashboard erstellt wird
  isNew: boolean = this.config.data.isNew;

  // Signal für die Anzeige des Icon-Dialogs
  showIconDialog = signal(false);

  // Ausgewähltes Icon
  selectedIcon: string | null = null;

  // Signal für das Dashboard-Objekt
  dashboard: WritableSignal<Dashboard> = this.config.data.dashboard;

  // Methode zum Speichern des Dashboards
  onSave() {
    if (this.isNew) {
      this.createDashboard(); // Neues Dashboard erstellen
    } else {
      this.updateDashboard(); // Bestehendes Dashboard aktualisieren
    }
  }

  // Methode zum Aktualisieren eines Dashboards
  private updateDashboard() {
    this.store.updateDashboard(this.dashboard().id, this.dashboard()).subscribe((success) => {
      if (success) {
        // Erfolgsnachricht anzeigen
        this.messageService.add({
          life: 3000,
          closable: true,
          severity: 'success',
          summary: 'Erfolgreich',
          detail: 'Dashboard erfolgreich aktualisiert.',
        });
        this.ref.close(); // Dialog schließen
      }
    });
  }

  // Methode zum Erstellen eines neuen Dashboards
  private createDashboard() {
    this.store.createDashboard(this.dashboard()).subscribe((success) => {
      if (success) {
        // Erfolgsnachricht anzeigen
        this.messageService.add({
          life: 3000,
          closable: true,
          severity: 'success',
          summary: 'Erfolgreich',
          detail: 'Dashboard erfolgreich gespeichert.',
        });
        this.ref.close(); // Dialog schließen
      }
    });
  }

  // Methode zum Abbrechen und Schließen des Dialogs
  onCancel() {
    this.ref.close();
  }

  // Methode, die aufgerufen wird, wenn ein Icon ausgewählt wird
  iconSelected($event: string) {
    this.selectedIcon = $event; // Ausgewähltes Icon speichern
    // Dashboard-Objekt mit dem neuen Icon aktualisieren
    this.dashboard.set({ ...this.dashboard(), icon: 'pi ' + this.selectedIcon });
  }
}
